<template>
  <div class="login">
    <div id="login" class="sec mt-10">
      <v-container>
        <v-row justify="center">
          <div
            class="display-2 head"
            data-aos="fade-up"
            :class="!MIXIN_SETUP_UI.show ? 'mt-5' : ''"
          >
            {{ title }}
          </div>
        </v-row>

        <v-card
          flat
          rounded="lg"
          data-aos="fade-up"
        >
          <div class="pa-4" v-html="termsAndConditions"></div>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Repository from "@/api/repositories";
const TermsAndConditionsApi = Repository.get("termsAndConditions");

export default {
  name: "Login",
  components: {
  },
  data() {
    return {
      title: "Terms And Conditions",
      termsAndConditions: null
    }
  },
  watch: {
    "$route.params.slug": {
      handler: function(value) {
        this.termsAndConditions = null;

        this.getTermsAndConditions(value);
      },
      immediate: true
    }
  },
  methods: {
    getTermsAndConditions(slug = "medgate") {
      TermsAndConditionsApi.showViaSlug(slug)
        .then(response => {
          let {
            data: {
              data: item
            }
          } = response;

          this.termsAndConditions = item.description;
        })
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.form {
  padding: 10%;
}

.left-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>